/**
 * Utility data user TIALAI dari localStorage
 */

export const getUserData = () => {
  const userStorage = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;

  const userName =
    userStorage && userStorage.nama
      ? userStorage.nama.split(" ")[0]
      : "Pengguna";

  return {
    userStorage,
    userName,
    userRole: userStorage?.role || null,
    userEmail: userStorage?.email || null,
    userUsername: userStorage?.username || null,
    // backward compat
    userProfile: undefined,
    userStatus: userStorage?.role?.toLowerCase() || null,
    userJenisPerusahaan: null,
  };
};

export const isRole = (...roles) => {
  const { userRole } = getUserData();
  return roles.includes(userRole);
};
